<template>
  <span v-if="smChipIncluded == true">
    <q-chip size="xs" color="grey-2" text-color="red" square>
      <sup
        class="text-green text-body2 text-weight-bolder"
        v-if="this.$store.state.market.marketStatus"
        >Live</sup
      >
      <sup class="text-red text-caption text-weight-bolder" v-else>Closed</sup>
    </q-chip>
  </span>
  <span v-if="smChipIncluded == false">
    <sup
      v-if="this.$store.state.market.marketStatus"
      class="text-bold live"
      style="color: #27ae60"
    >
      <q-icon name="adjust" />
      Live
    </sup>

    <sup v-else class="text-bold live" style="color: red">
      <q-icon name="adjust" />
      Closed
    </sup>
  </span>
</template>

<script>
export default {
  props: {
    smChipIncluded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {};
  },
};
</script>
